// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "main-static/js/" + chunkId + "." + {"236":"404c4a8f","317":"58f3b330","373":"264f5af8","402":"fd9c29ee","407":"227cf261","551":"20f3c439","580":"26953584","725":"23c047a0","745":"05c2a3b1","763":"1bcff48c","960":"43052ebb","968":"61303910"}[chunkId] + ".chunk.js";
};